/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {PageInitializeAction} from '@/types/redux';

export const INITIALIZE_ISSUES = 'INITIALIZE_ISSUES';

/**
 * @initialize
 */
export const initializeIssues = (): PageInitializeAction => {
  return {type: INITIALIZE_ISSUES};
};
